import React from 'react';

import './index.scss';
import helper from '../../../Conversations/helpers';

const getPhoneNumber = (contacts) => {
  const phoneDetails = contacts.find((contact) => contact.type === 'PHONE');
  const alternate = contacts.filter((contact) => {
    if (contact.type === 'PHONE') {
      return contact.value.trim();
    }
  });
  if (alternate.length > 0) {
    return helper.formatPhoneNumber(alternate[0].value) || '';
  } else {
    return '';
  }
};

const getEmail = (contacts) => {
  const emailDetails = contacts.find((contact) => contact.type === 'EMAIL');
  if (emailDetails) {
    return emailDetails.value;
  } else {
    return '';
  }
};

const ProfileInfo = ({ details, selectedSchedule }) => {
  console.log('Details', details[0], selectedSchedule);
  return (
    <div className="client-profile__card">
      <h1 className="client-profile__card__heading">Profile info</h1>
      <div className="client-profile__card__content">
        <ul>
          {details[0] &&
          details[0].contacts &&
          getPhoneNumber(details[0].contacts, selectedSchedule) ? (
            <li>
              <span className="client-profile__card__content__list-head">
                Alternate phone number:
              </span>
              <span className="client-profile__card__content__list-text">
                {getPhoneNumber(details[0].contacts, selectedSchedule)}
              </span>
            </li>
          ) : null}

          {details[0] &&
          details[0].contacts &&
          getEmail(details[0].contacts) ? (
            <li>
              <span className="client-profile__card__content__list-head">
                Email:{' '}
              </span>
              <span className="client-profile__card__content__list-text">
                {getEmail(details[0].contacts)}
              </span>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

export default ProfileInfo;
